import React, { type PropsWithChildren, useCallback } from 'react';

import { AnalyticsListener, type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { ANALYTICS_BRIDGE_CHANNEL } from '@atlassian/analytics-bridge';

import { type AnalyticsSettings } from './types';

export const AnalyticsProvider = ({ children, channel }: PropsWithChildren<AnalyticsSettings>) => {
	const sendEvent = useCallback(
		(event: UIAnalyticsEvent) => {
			// For backwards compatibility with analytics listeners in the product
			// which attempt to determine the actionSubject and attributes
			// from the context.
			const { actionSubject, attributes } = event.payload;
			const context: Record<string, string> = {};
			if (actionSubject) {
				context.component = actionSubject;
				context.componentName = actionSubject;
			}
			if (attributes) {
				context.attributes = attributes;
			}
			event.context.push(context);

			event.clone()?.fire(channel);
		},
		[channel],
	);

	return (
		<AnalyticsListener channel={ANALYTICS_BRIDGE_CHANNEL} onEvent={sendEvent}>
			{children}
		</AnalyticsListener>
	);
};
